import { useState } from 'react'
import Header from '../Header/Header.js'
import Footer from '../Footer/Footer.js'
import { MdErrorOutline } from "react-icons/md";
import { SlLocationPin, SlEnvolope } from "react-icons/sl";
import { GoCircle } from "react-icons/go";
import AddressModal from './AddressModel.js';
import AddressDetailsModel from './AddressDetailsModel.js';
import { useLocation } from 'react-router-dom';
import { FaCaretRight, FaCheckCircle } from "react-icons/fa";
import { useMutation, useQuery } from '@apollo/client';
import { CREATE_ORDER } from '../graphql/Mutation/Ordre.js';
import DeliveryModal from './DeliveryModal.js';
import DeliveryDetailsModel from './DeliveryDetailsModel.js';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import Select from 'react-select';
import * as Yup from 'yup';
import { GET_DELIVERY_ADDRESS } from '../graphql/Query/GetDeliveryOfCustomer.js';
import { GET_RECEIVER_DATA } from '../graphql/Query/GetReceiverOfCustomer.js';
import './documentShipping.css'
import SpinLoader from '../components/SpinLoader.js';
import { toast } from 'react-toastify';
import { FaRegEdit } from "react-icons/fa";
import { BsBox } from "react-icons/bs";
import useScrollToTop from '../components/useScrollToTop.js';
import { generateDeliveryLink } from '../Common/CalculateRate.js';
import { GET_BANK_DETAILS_BY_ID } from '../graphql/Query/SellerPruff.js';
import BankDetailsModal from '../CalculatorCourier/BankDetailsModal.js';

const options = [
    { value: 'document', label: 'Documents' },
    { value: 'Books', label: 'Books' },
    { value: 'Clothes & Personal Items', label: 'Clothes & Personal Items' },
    { value: 'Consumables', label: 'Consumables' },
    { value: 'Electronics', label: 'Electronics' },
    { value: 'Household Items', label: 'Household Items' },
    { value: 'Sports Equipment', label: 'Sports Equipment' },
    { value: 'Furniture', label: 'Furniture' },
    { value: 'Jewelry & Accessories', label: 'Jewelry & Accessories' },
    { value: 'Beauty & Personal Care', label: 'Beauty & Personal Care' },
    { value: 'Toys & Games', label: 'Toys & Games' },
    { value: 'Office Supplies', label: 'Office Supplies' },
    { value: 'Groceries', label: 'Groceries' },
    { value: 'Health & Beauty', label: 'Health & Beauty' },
    { value: 'Automotive', label: 'Automotive' },
    { value: 'Musical Instruments', label: 'Musical Instruments' },
    { value: 'Gardening Tools', label: 'Gardening Tools' },
    { value: 'Kitchen Appliances', label: 'Kitchen Appliances' },
    { value: 'Pet Supplies', label: 'Pet Supplies' },
    { value: 'Art & Craft', label: 'Art & Craft' },
    { value: 'Baby Products', label: 'Baby Products' },
    { value: 'Tools & Hardware', label: 'Tools & Hardware' },
    { value: 'Travel Accessories', label: 'Travel Accessories' },
    { value: 'Industrial Supplies', label: 'Industrial Supplies' },
    { value: 'Bags & Luggage', label: 'Bags & Luggage' },
    { value: 'Footwear', label: 'Footwear' },
    { value: 'Home Decor', label: 'Home Decor' },
    { value: 'Other', label: 'Other' },
];


const DocumentShipping = ({ session }) => {
    const [showBankModal, setShowBankModal] = useState(false);
    useScrollToTop();
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [pageDelivery, setPageDelivery] = useState(0);
    const [limitDelivery, setLimitDelivery] = useState(10);
    const [searchDeliveryAddress, setSearchDelhiveryAddress] = useState('')

    const location = useLocation();
    const imageurl = location?.state?.key
    const [showModal, setShowModal] = useState(false);
    const [showModalAddress, setShowModalAddress] = useState(false);

    const [deliveryshowModal, setdeliveryShowModal] = useState(false);
    const [deliveryModal, setdeliveryModal] = useState(false);

    const [paymentShowModel, setPaymentShowModel] = useState(false);
    const [setHandlePayModel] = useState(false);
    const [WeightType, setWeightType] = useState('');
    const [weightInput, setWeightInput] = useState('');
    const [selectedPickupAddress, setSelectedPickupAddress] = useState('');
    const [selectedDeliveryAddress, setSelectedDeliveryAddress] = useState('');
    // const [paymentSessionId, setSessionId] = useState();
    const [data, setData] = useState([]);
    const [ProductName, setProductName] = useState('');
    // console.log('✌️ProductName --->', ProductName);
    const [ProductPrice, setProductPrice] = useState('');
    const [paymentType, setPaymentType] = useState('');
    const [pickupId, setPickupId] = useState('');
    const [deliveryId, setDeliveryId] = useState('');
    const [courier_id, setcourier_id] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(generateDeliveryLink(id));
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };
    const id = localStorage.getItem('id');

    const { data: getDeliveryData, refetch, loading } = useQuery(GET_DELIVERY_ADDRESS, {
        variables: {
            "customerId": id,
            "page": pageDelivery + 1,
            "limit": limitDelivery,
            "sort": {
                "key": "createdAt",
                "type": -1
            },
            "filter": searchDeliveryAddress
        },
        fetchPolicy: 'cache-and-network',
    });
    const { data: getReceiverData, refetch: reciverRefetch } = useQuery(GET_RECEIVER_DATA, {
        variables: {
            "customerId": id,
            "page": page + 1,
            "limit": limit,
            "sort": {
                "key": "createdAt",
                "type": -1
            },
        },
        fetchPolicy: 'cache-and-network',
    });
    const { data: getBankDetails } = useQuery(GET_BANK_DETAILS_BY_ID, {
        fetchPolicy: "cache-and-network"
    })

    const [pickupAddress, setPickupAddress] = useState({
        warehouse_name: '',
        name: '',
        address1: '',
        city: '',
        stateId: {
            id: '',
            name: '',
        },
        zipCode: '',
        phone: ''
    });
    // console.log('✌️pickupAddress --->', pickupAddress);
    const [deliveryAddress, setDeliveryAddress] = useState({
        name: '',
        address1: '',
        city: '',
        stateId: {
            id: '',
            name: '',
        },
        zipCode: '',
        phone: ''
    });
    const [addOrder] = useMutation(CREATE_ORDER);

    const handleCloseAddressDetails = () => {
        setShowModalAddress(false);
        setShowModal(true);
    };
    const handleCloseDeliveryDetails = () => {
        setdeliveryModal(false);
        setdeliveryShowModal(true)
        setDeliveryId("");
    };

    const capitalizeFirstLetter = (text) => {
        if (!text) return text;
        return text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    };

    const validationSchema = Yup.object({
        // weight: Yup.string().required('Weight is required'),
        ProductPrice: Yup.number()
            .required('Product Value is required')
            .positive('Product Value must be a positive number')
            .typeError('Product Value must be a number'),
        productCategory: Yup.object()
            .shape({
                value: Yup.string().required('Product Category is required'),
            })
            .required('Product Category is required'),
        paymentType: Yup.string()
            .required('Payment Type is required'),
    });
    const allBinsHandleChange = (selectedValue, setFieldValue) => {
        setProductName(selectedValue?.value);
        setFieldValue('productCategory', selectedValue);
    };
    const PaymentOptions = [

        { value: "prepaid", label: "Prepaid" },
        { value: "cod", label: "Cash on Delivery(COD)" },
    ];
    return (
        <div>
            <Header />
            <div className="relative isolate overflow-hidden bg-slate-900 py-16 sm:py-10">
                <img
                    src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/tailwindimg.avif"
                    alt=""
                    className="absolute inset-0 -z-10 h-full w-full object-cover object-right md:object-center"
                />
                <div
                    className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl"
                    aria-hidden="true"
                >
                    <div
                        className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>
                <div
                    className="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu"
                    aria-hidden="true"
                >
                    <div
                        className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>
                <div className="mx-auto max-w-auto md:p-6 lg:px-8">
                    <div className="flex flex-col lg:flex-row gap-y-10 justify-between">
                        <Formik
                            initialValues={{
                                pickupAddress: '', deliveryAddress: '', paymentType: '', ProductPrice: '', codValue: '',
                                payment_type: '', productCategory: null
                            }}
                            validationSchema={validationSchema}
                            onSubmit={async (values, { resetForm }) => {
                                // console.log('✌️values --->', values);
                                const errors = [];
                                if (!selectedPickupAddress) errors.push("Pickup Address");
                                if (!selectedDeliveryAddress) errors.push("Delivery Address");
                                // if (!WeightType) errors.push("Weight Type");
                                // if (!weightInput) errors.push("Weight Input");
                                if (!ProductName) errors.push("Product Name");
                                if (!ProductPrice) errors.push("Product Price");
                                if (!paymentType) errors.push("Payment Type");

                                if (errors?.length > 0) {
                                    const errorMessage = ` ${errors.join(', ')}. required fields`;
                                    toast.error(errorMessage);
                                    return;
                                }
                                setIsLoading(true);
                                try {
                                    const pickupAddress = {
                                        warehouse_name: selectedPickupAddress?.warehouse_name,
                                        name: selectedPickupAddress?.name,
                                        address1: selectedPickupAddress?.address1,
                                        city: selectedPickupAddress?.city,
                                        stateId: selectedPickupAddress?.stateId,
                                        zipCode: selectedPickupAddress?.zipCode,
                                        phone: selectedPickupAddress?.phone,
                                        customerId: selectedPickupAddress?.customerId,
                                        _id: selectedPickupAddress?.id,
                                        email: session?.me?.email,
                                        SellerId: session?.me?.SellerId
                                    }
                                    const deliveryAddress = {
                                        name: selectedDeliveryAddress?.name,
                                        address1: selectedDeliveryAddress?.address1,
                                        city: selectedDeliveryAddress?.city,
                                        stateId: selectedDeliveryAddress?.stateId,
                                        zipCode: selectedDeliveryAddress?.zipCode,
                                        phone: selectedDeliveryAddress?.phone,
                                        isDeliverToVillage: selectedDeliveryAddress?.isDeliverToVillage,
                                        VillageName: selectedDeliveryAddress?.VillageName,
                                        extraChargeOfVillage: selectedDeliveryAddress?.extraChargeOfVillage,
                                        distanceFromTalukaKm: selectedDeliveryAddress?.distanceFromTalukaKm,
                                        customerId: selectedDeliveryAddress?.customerId,
                                        _id: selectedDeliveryAddress?.id,
                                        email: selectedDeliveryAddress?.email,
                                        alternateMobileNumber: selectedDeliveryAddress?.alternateMobileNumber
                                    }
                                    const { data } = await addOrder({
                                        variables: {
                                            input: {
                                                pickupAddress,
                                                deliveryAddress,
                                                // package_weight: parseFloat(weightInput),
                                                // package_weight_Length: WeightType,
                                                // courier_id: courier_id,
                                                ProductName: ProductName,
                                                ProductPrice: ProductPrice,
                                                codCollectableValue: paymentType === "cod" ? parseFloat(ProductPrice) : null,
                                                payment_type: paymentType === "cod" ? "COD" : "Prepaid"

                                            }
                                        }
                                    });
                                    // console.log('✌️data --->', data);
                                    if (data?.addOrder) {
                                        setPaymentShowModel(true);
                                        // setData(data?.addOrder);
                                        setIsLoading(false);
                                        resetForm();
                                        setPaymentType("");
                                        setProductName("");
                                        setSelectedPickupAddress("");
                                        setProductPrice("");
                                        setDeliveryId("");
                                        setPickupId("");
                                        setSelectedDeliveryAddress("");
                                        toast.success("Order Create SuccessFully")
                                        // if (data?.addOrder?.paymentSessionId) {
                                        //     setSessionId(data?.addOrder?.paymentSessionId);
                                        // }
                                    }
                                } catch (err) {
                                    toast.error(err?.message)
                                    setIsLoading(false);
                                }
                            }}
                        >
                            {({ setFieldValue, values }) => (
                                <Form className="w-full lg:w-2/3 bg-white md:p-8 p-6 md:rounded-l-lg shadow-md">
                                    <div className='space-y-8'>
                                        <div className='flex justify-between'>
                                            <div className='flex'>


                                                {imageurl ? <BsBox className='text-3xl me-3 text-gray-900 drop-shadow-xl' /> : <SlEnvolope className='text-4xl me-3 text-gray-900 drop-shadow-lg' />}
                                                {imageurl ? <h1 className="text-xl font-bold">Domestic parcel in india</h1> : <h1 className="text-xl font-bold">Document ex.Letter, Paper etc. Ship now</h1>}

                                            </div>
                                            <h1 className="font-bold hidden md:block text-slate-600">1 / 1</h1>
                                        </div>
                                        <div className='flex space-x-4'>
                                            {/* line  */}
                                            <div className='space-y-1 text-gray-400'>
                                                <GoCircle />
                                                <ul className='ms-1.5'>
                                                    <li className='text-xs leading-3'>I</li>
                                                    <li className='text-xs leading-3'>I</li>
                                                    <li className='text-xs leading-3'>I</li>
                                                    <li className='text-xs leading-3'>I</li>
                                                    <li className='text-xs leading-3'>I</li>
                                                    <li className='text-xs leading-3'>I</li>
                                                    <li className='text-xs leading-3'>I</li>
                                                    <li className='text-xs leading-3'>I</li>
                                                    <li className='text-xs leading-3'>I</li>
                                                    <li className='text-xs leading-3'>I</li>
                                                </ul>
                                                <SlLocationPin />
                                            </div>
                                            <div className='space-y-7 flex-initial w-full text-ellipsis overflow-hidden'>
                                                <div className="mb-4">
                                                    <label className="block text-gray-700 text-sm font-semibold mb-3" htmlFor="pickupAddress">
                                                        Pickup Address <span className="text-red-500">*</span>
                                                    </label>
                                                    {!selectedPickupAddress && <div className="relative">
                                                        <Field
                                                            name="pickupAddress"
                                                            className="flex w-full cursor-pointer items-center border-slate-500 border rounded-lg py-2 px-3 focus:outline-none focus:ring-slate-800 focus:border-slate-800"
                                                            placeholder="pickup address"
                                                            onClick={() => setShowModal(true)}
                                                            readOnly
                                                        />
                                                        <FaCaretRight className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-800" />
                                                    </div>}
                                                    <ErrorMessage name="pickupAddress" component="div" className="text-red-500 text-sm mt-2" />
                                                    {selectedPickupAddress && (
                                                        <ul className="space-y-6 md:space-y-5 mt-3 border border-slate-300 p-4 rounded-xl">
                                                            <li className="flex justify-between cursor-pointer items-center text-ellipsis overflow-hidden" onClick={() => setShowModal(true)}>
                                                                <div className="flex items-center">
                                                                    <div>
                                                                        <div className="flex space-x-2 mb-1.5">
                                                                            <p className="font-semibold md:text-black text-gray-800 text-sm">{capitalizeFirstLetter(selectedPickupAddress?.name)}</p>
                                                                            <p className="text-sm self-center text-gray-500">l +91 {(selectedPickupAddress?.phone)}</p>
                                                                        </div>
                                                                        <div>
                                                                            <p className="text-slate-500 font-normal text-sm text-wrap">{capitalizeFirstLetter(selectedPickupAddress?.address1)}.</p>
                                                                            <p className="text-slate-500 font-normal text-sm text-wrap">{capitalizeFirstLetter(selectedPickupAddress?.city)}. {capitalizeFirstLetter(selectedPickupAddress?.stateId)} - {capitalizeFirstLetter(selectedPickupAddress?.zipCode)}</p>
                                                                        </div>
                                                                        <div className='font-semibold mt-4 flex space-x-1 items-center text-green-600' onClick={() => setShowModal(true)}>
                                                                            <FaRegEdit className='text-lg text-green-600' />
                                                                            <p className='text-xs text-green-600'>ADDRESS UPDATE</p>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    )}
                                                </div>


                                                <div className="mb-4">
                                                    <label className="block text-gray-700 text-sm font-semibold mb-3" htmlFor="deliveryAddress">
                                                        Delivery Address <span className="text-red-500">*</span>
                                                        <p
                                                            onClick={handleCopy}
                                                            className="cursor-pointer px-3 py-1 inline-flex bg-slate-800 text-white text-sm font-medium rounded-md md:ms-3 mt-2 md:mt-0 items-center gap-2 hover:bg-slate-800 transition"
                                                        >
                                                            {copied ? (
                                                                <>
                                                                    <FaCheckCircle className="text-green-400" />
                                                                    Copied!
                                                                </>
                                                            ) : (
                                                                "Generate & Share Delivery Link"
                                                            )}
                                                        </p>
                                                    </label>
                                                    {!selectedDeliveryAddress && <div className="relative">
                                                        <Field
                                                            name="deliveryAddress"
                                                            className="flex w-full cursor-pointer items-center border-slate-500 border rounded-lg py-2 px-3 focus:outline-none focus:ring-slate-800 focus:border-slate-800"
                                                            placeholder="delivery address"
                                                            onClick={() => setdeliveryShowModal(true)}
                                                            readOnly
                                                        />
                                                        <FaCaretRight className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-800" />
                                                    </div>}
                                                    <ErrorMessage name="deliveryAddress" component="div" className="text-red-500 text-sm mt-2" />
                                                    {selectedDeliveryAddress &&
                                                        <ul className="space-y-6 md:space-y-5 mt-3 border border-slate-300 p-4 rounded-xl ">
                                                            <li className="flex justify-between cursor-pointer items-center text-ellipsis overflow-hidden" onClick={() => setdeliveryShowModal(true)}>
                                                                <div className="flex items-center">
                                                                    <div>
                                                                        <div className='flex space-x-2 mb-1.5'>
                                                                            <p className="font-semibold md:text-black text-gray-800 text-sm">{capitalizeFirstLetter(selectedDeliveryAddress?.name)}</p>
                                                                            <p className='text-sm self-center text-gray-500'>l +91 {(selectedDeliveryAddress?.phone)} {(selectedDeliveryAddress?.alternateMobileNumber ? `| ${selectedDeliveryAddress?.alternateMobileNumber}` : "")}</p>
                                                                        </div>
                                                                        <div>
                                                                            <p className="text-slate-500 font-normal text-sm text-wrap">{capitalizeFirstLetter(selectedDeliveryAddress?.address1)}.</p>
                                                                            <p className="text-slate-500 font-normal text-sm text-wrap">{capitalizeFirstLetter(selectedDeliveryAddress?.city)}.  {capitalizeFirstLetter(selectedDeliveryAddress?.stateId)} - {capitalizeFirstLetter(selectedDeliveryAddress?.zipCode)}</p>
                                                                        </div>
                                                                        {selectedDeliveryAddress?.isDeliverToVillage ?
                                                                            <div>
                                                                                <p className="text-slate-500 text-sm text-wrap">Village Delivery: {selectedDeliveryAddress?.isDeliverToVillage ? "Yes" : "No"}</p>
                                                                                <p className="text-slate-500 text-sm text-wrap"> Village Name: {selectedDeliveryAddress?.VillageName} <br /> Extra Charge of Village : {selectedDeliveryAddress?.extraChargeOfVillage} <br /> Distance From Taluka:{selectedDeliveryAddress?.distanceFromTalukaKm}</p>
                                                                            </div> : ""}
                                                                        <div className='font-semibold mt-4 flex space-x-1 items-center text-green-600' onClick={() => setdeliveryShowModal(true)}>
                                                                            <FaRegEdit className='text-lg text-green-600' />
                                                                            <p className='text-xs text-green-600'>ADDRESS UPDATE</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            {/* <div className="relative z-50">
                                                <label className='text-gray-700 text-sm font-semibold mb-3'>Weight (Kg) <span className="text-red-500">*</span></label>
                                                <div className="mt-2 z-50">
                                                    <Field name="weight">
                                                        {({ field, form }) => {
                                                            const selectedOption = weightOptions?.find(option => option?.value === field?.value);
                                                            return (
                                                                <Select
                                                                    value={weightOptions?.find(option => option?.value === field?.value) || ""}
                                                                    options={weightOptions}
                                                                    className="w-full focus:outline-none z-50"
                                                                    styles={{
                                                                        control: (base, state) => ({
                                                                            ...base,
                                                                            borderColor: state.isFocused ? '#64748B' : '#64748B',
                                                                            '&:hover': { borderColor: '#64748B' },
                                                                            boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                                            borderRadius: '0.375rem',
                                                                        }),
                                                                        singleValue: (base) => ({
                                                                            ...base,
                                                                            color: '#000000',
                                                                        }),
                                                                        option: (base, state) => ({
                                                                            ...base,
                                                                            backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                                                            color: state.isSelected ? 'white' : '#000000',
                                                                            '&:hover': {
                                                                                backgroundColor: '#f0f0f0',
                                                                                color: '#000000',
                                                                            }
                                                                        }),
                                                                        placeholder: (base) => ({
                                                                            ...base,
                                                                            fontSize: '13.7px',
                                                                            color: '#A3AAB5',
                                                                        }),
                                                                    }}
                                                                    isSearchable={false}
                                                                    placeholder="Select Weight"

                                                                    onChange={option => {
                                                                        form.setFieldValue(field.name, option.value);
                                                                        handleButtonClick(option.value);
                                                                    }}
                                                                    onBlur={() => form.setFieldTouched(field.name, true)}
                                                                />
                                                            );
                                                        }}
                                                    </Field>
                                                    <ErrorMessage name="weight" component="div" className="text-red-600 text-sm mt-1 z-50" />
                                                </div>
                                            </div> */}


                                            <div className="relative z-40 mt-6">
                                                <label className=' text-sm font-medium text-gray-700'>
                                                    Payment Type <span className="text-red-500">*</span>
                                                </label>
                                                <div className="mt-2 z-50">
                                                    <Field name="paymentType">
                                                        {({ field, form }) => {
                                                            return (
                                                                <div>
                                                                    <Select
                                                                        value={PaymentOptions.find((option) => option.value === field?.value) || ""}
                                                                        options={PaymentOptions}
                                                                        className="w-full focus:outline-none z-50"
                                                                        styles={{
                                                                            control: (base, state) => ({
                                                                                ...base,
                                                                                borderColor: '#2b2b2b',
                                                                                '&:hover': { borderColor: '#2b2b2b' },
                                                                                boxShadow: state.isFocused
                                                                                    ? '0 0 0 0px #000000'
                                                                                    : 'none',
                                                                                zIndex: 1050,
                                                                            }),
                                                                            singleValue: (base) => ({
                                                                                ...base,
                                                                                color: '#000000',
                                                                                zIndex: 1050,
                                                                            }),
                                                                            option: (base, state) => ({
                                                                                ...base,
                                                                                backgroundColor: state.isSelected
                                                                                    ? '#000000'
                                                                                    : state.isFocused
                                                                                        ? '#f0f0f0'
                                                                                        : 'white',
                                                                                color: state.isSelected
                                                                                    ? 'white'
                                                                                    : '#000000',
                                                                                '&:hover': {
                                                                                    backgroundColor: '#f0f0f0',
                                                                                    color: '#000000',
                                                                                },
                                                                                zIndex: 1050,
                                                                            }),
                                                                            menu: (base) => ({
                                                                                ...base,
                                                                                zIndex: 1050,
                                                                                position: 'absolute',
                                                                            }),
                                                                            placeholder: (base) => ({
                                                                                ...base,
                                                                                fontSize: '13.7px',
                                                                                color: '#A3AAB5',
                                                                            }),
                                                                        }}
                                                                        isSearchable={false}
                                                                        placeholder="Select Payment Type"
                                                                        // onChange={(option) => {
                                                                        // setPaymentType(option?.value || '');
                                                                        // form.setFieldValue(field.name, option?.value || "");
                                                                        // if (
                                                                        //     option?.value === 'cod'
                                                                        // ) {
                                                                        //     setCodPrice(''); // Set codValue for COD
                                                                        //     form.setFieldValue('codValue', ''); // Initialize the input field value
                                                                        // } else {
                                                                        //     setCodPrice(null);
                                                                        //     form.setFieldValue('codValue', null); // Clear the input field for other options
                                                                        // }
                                                                        // }}
                                                                        onChange={(option) => {
                                                                            if (option?.value === 'cod' && (!getBankDetails?.getBankDetailsById?.accountNumber && !getBankDetails?.getBankDetailsById?.bankHolderName)) {
                                                                                setShowBankModal(true);
                                                                            } else {
                                                                                form.setFieldValue(field.name, option?.value || "");
                                                                                setPaymentType(option?.value || '');
                                                                            }
                                                                        }}

                                                                        onBlur={() => form.setFieldTouched(field.name, true)}
                                                                    />
                                                                </div>
                                                            );
                                                        }}
                                                    </Field>
                                                    <ErrorMessage
                                                        name="paymentType"
                                                        component="div"
                                                        className="text-red-600 text-sm mt-1 z-50"
                                                    />
                                                </div>
                                            </div>



                                            <div className='my-6'>
                                                <label htmlFor="ItemSelect" className="block text-sm font-medium text-gray-700 mb-2.5">
                                                    Products Category <span className="text-red-500">*</span>
                                                </label>
                                                <Select
                                                    className="basic-single ffPoppins"
                                                    options={options}
                                                    value={values?.productCategory}
                                                    onChange={(selectedValue) => allBinsHandleChange(selectedValue, setFieldValue)}
                                                    styles={{
                                                        control: (base, state) => ({
                                                            ...base,
                                                            borderColor: state.isFocused ? '#64748B' : '#64748B',
                                                            '&:hover': { borderColor: '#64748B' },
                                                            boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                            borderRadius: '0.375rem',
                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            color: '#000000',
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                                            color: state.isSelected ? 'white' : '#000000',
                                                            '&:hover': {
                                                                backgroundColor: '#f0f0f0',
                                                                color: '#000000',
                                                            },
                                                        }),
                                                        placeholder: (base) => ({
                                                            ...base,
                                                            fontSize: '13.7px',
                                                            color: '#A3AAB5',
                                                        }),
                                                    }}
                                                    isSearchable={false}
                                                    placeholder="Select Package Category"
                                                />
                                                <ErrorMessage name="productCategory.value" component="div" className="text-red-500 text-sm mt-2" />
                                            </div>

                                            <div>


                                                <label htmlFor="ProductPrice" className="block text-sm font-medium text-gray-700 mb-2.5">
                                                    {paymentType === "cod" ? (
                                                        <>
                                                            COD (Cash on Delivery) Collectible Amount(₹)<span className="text-red-500">*</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            Total Value of Products (₹)
                                                            <span className="text-red-500">*</span>
                                                        </>
                                                    )}
                                                </label>
                                                <div className="mt-1 flex rounded-md shadow-sm">
                                                    <Field
                                                        type="number"
                                                        id="ProductPrice"
                                                        name="ProductPrice"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (value?.length <= 4) {
                                                                setFieldValue('ProductPrice', value);
                                                                setProductPrice(value);
                                                            }
                                                        }}
                                                        onWheel={(e) => e.target.blur()}
                                                        className="flex-1 block w-full px-3 py-2 border border-slate-500 rounded-md focus:outline-none focus:ring-black focus:border-black sm:text-sm"
                                                        placeholder="Enter Value Ex.Rs.199"
                                                    />
                                                </div>
                                                <ErrorMessage name="ProductPrice" component="div" className="text-red-500 text-sm mt-2" />
                                            </div>
                                        </div>
                                        <div className='mt-6'>
                                            <div className='flex space-x-2'>
                                                <MdErrorOutline className='text-xl' />
                                                <p className='text-sm font-semibold'>Book before 2pm remaining for the Same-Day Pickup</p>
                                            </div>
                                            <p className='text-xs mt-1'>Your Shipment Delivery: Minimum 1 - Maximum 4 Days (Depending on the location)</p>
                                        </div>
                                        <button
                                            className={`w-full bg-slate-800 text-white p-2 rounded-lg hover:bg-slate-900 transition duration-300 ${isLoading ? 'cursor-not-allowed' : ''}`}
                                            type="submit"
                                            // onClick={createOrderData}
                                            disabled={isLoading}
                                        >
                                            <div className='flex justify-center'>
                                                <span className='me-2 font-semibold'>Create Shipment</span>
                                                {isLoading && <SpinLoader />}
                                            </div>
                                        </button>

                                        {/* <div>
                                            <h1 className="text-lg font-semibold text-gray-800 mb-6">
                                                Incorrect Weight Entry for Shipment Shipments: Valid and Invalid Scenarios
                                            </h1>
                                            <p className="text-gray-700 mb-6">
                                                When shipping parcels, it’s crucial to enter the correct weight for your packages. Entering the wrong weight can cause delays, returns, or additional charges. Here’s how different scenarios are handled:
                                            </p>

                                            <div className="mb-4">
                                                <h2 className=" font-semibold text-gray-800 mb-2">
                                                    1. Small Weight Discrepancies (400 to 700 gm): Valid
                                                </h2>
                                                <p className="text-gray-700">
                                                    Minor weight differences ranging from 400 to 700 grams are generally considered acceptable. In such cases, your shipment will still be processed without being returned, as long as it doesn’t significantly impact the shipping cost or logistics.
                                                </p>
                                            </div>

                                            <div className="mb-4">
                                                <h2 className=" font-semibold text-gray-800 mb-2">
                                                    2. Large Weight Discrepancies: Invalid and Return
                                                </h2>
                                                <p className="text-gray-700">
                                                    If a substantial weight difference is entered—such as declaring a much lighter weight for a significantly heavier package—the shipment will be marked as invalid. In such cases, your Shipment will likely be returned to the sender, and you may be charged additional fees for the discrepancy.
                                                </p>
                                            </div>
                                            <div>
                                                <h2 className=" font-semibold text-gray-800 mb-2">
                                                    3. Your Shipment Delivery: Minimum 1 - Maximum 6 Days
                                                </h2>
                                                <p className="text-gray-700">
                                                    At AlgarXpress, we ensure efficient and timely delivery of your parcels. Depending on the location and service selected, your Shipment will be delivered within a minimum of 1 day and a maximum of 6 days. Our goal is to provide fast and reliable service, keeping your needs in mind while ensuring that your shipments arrive safely within the given timeframe.
                                                </p>
                                            </div>
                                        </div> */}
                                    </div>
                                </Form>
                            )}
                        </Formik>
                        <div className="w-full lg:w-1/3 bg-white p-6 md:rounded-r-lg shadow-md mt-6 lg:mt-0 lg:ml-3">

                            {/* <div className="h-48 bg-slate-100 mb-3 p-4 rounded-xl flex flex-col justify-center items-center">
                                <div className="text-center">
                                    <h2 className="text-xl font-bold text-gray-800 mb-2">Create Bulk Shipment</h2>
                                    <p className="text-gray-600 text-sm">Quickly create and manage multiple shipments with ease. Track, update, and streamline your shipping process effortlessly</p>
                                </div>
                                <Link to='/bulkcourier'> <button className="mt-4 px-6 py-1.5 bg-slate-800 text-white rounded-lg hover:bg-slate-900 transition duration-300">
                                    Bulk Shipping
                                </button></Link>
                            </div> */}


                            {/* {imageurl ? <video
                                // controls
                                autoPlay
                                loop
                                muted
                                className="rounded-xl mb-3"
                            >
                                <source src="https://uklogistics.s3.ap-south-1.amazonaws.com/Video/Untitled+1_1080p.mp4" type="video/mp4" className='cursor-pointer rounded-xl' />
                                Your browser does not support the video tag.
                            </video>
                                :
                                <video
                                    // controls
                                    autoPlay
                                    loop
                                    muted
                                    className="rounded-xl mb-3"
                                >
                                    <source src="https://uklogistics.s3.ap-south-1.amazonaws.com/Video/Untitled+2_1080p_2.mp4" type="video/mp4" className='cursor-pointer rounded-xl' />
                                    Your browser does not support the video tag.
                                </video>
                            } */}
                            {/* {imageurl ? <img src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/boxs.jpg" alt="" className='rounded-lg hover:opacity-80' /> : <img src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/gg1.jpg" alt="" className='rounded-lg hover:opacity-80' />} */}
                            {/* {imageurl ? <img src={cbox} alt="" className='rounded-lg hover:opacity-80 mt-3' /> : <img src={dbox} alt="" className='rounded-lg hover:opacity-80 mt-3 h-40' />} */}
                            <h2 className="text-xl font-semibold mb-6">Things to keep in mind</h2>
                            <div className="mb-4">
                                <h3 className="font-semibold text-slate-800 text-sm">Package Weight</h3>
                                <p className="text-gray-500 text-sm">We only deliver packages up to 30kgs.</p>
                            </div>
                            <div className="mb-4">
                                <h3 className="font-semibold text-slate-800 text-sm">Packaging</h3>
                                <p className="text-gray-500 text-sm">We do not provide packaging service. Please keep the items packed for our delivery executive to pickup.</p>
                            </div>
                            <div className="mb-4">
                                <h3 className="font-semibold text-slate-800 text-sm">Restricted/Illegal item</h3>
                                <p className="text-gray-500 text-sm">Please ensure you are not sending any restricted/illegal item</p>
                            </div>
                            <div className="mb-4">
                                <h3 className="font-semibold text-slate-800 text-sm">Multiple packages</h3>
                                <p className="text-gray-500 text-sm">We only allow one box/package/parcel per Shipment</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mx-auto max-w-auto md:p-6 lg:px-8 my-7 px-6">
                {/* <div>
                    <h1 className="text-2xl font-bold mb-4"> Labelling of the Shipment</h1>
                    <p className="text-gray-700 mb-6">
                        Proper labelling is crucial for faster & safe handling of the shipment
                        in reaching the intended destination.
                    </p>

                    <div className="grid md:grid-cols-2 gap-6">
                        <div>
                            <h2 className="text-xl font-semibold mb-2">Shipment Label</h2>
                            <table className="w-full border-collapse border border-gray-300 text-left mb-6">
                                <thead>
                                    <tr>
                                        <th className="border border-gray-300 p-2">Essential Data</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="border border-gray-300 p-2">
                                            <ul className="list-disc list-inside">
                                                <li>Barcode</li>
                                                <li>
                                                    Waybill number and barcode (Incase of shipments of order
                                                    value above 50,000)
                                                </li>
                                                <li>Shipment number & barcode</li>
                                                <li>Consignee address</li>
                                                <li>Return address</li>
                                                <li>Retail / Tax Invoice</li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="flex justify-center">
                            <img
                                src="https://uklogistics.s3.ap-south-1.amazonaws.com/packaging-guidline/labels.jpeg"
                                alt="Shipment Label Example"
                                className="rounded-lg h-96 shadow-lg border border-gray-200"
                            />
                        </div>
                    </div>
                </div>

                <div>
                    <h1 className="text-2xl font-bold mb-4">Labelling of the shipment</h1>
                    <p className="text-gray-700 mb-6">
                        The label should be pasted at the right location to make it compatible with the requirements of logistics system for a fast &
                        efficient delivery

                    </p>

                    <div className="grid md:grid-cols-2 gap-6">
                        <div>
                            <h2 className="text-xl font-semibold mb-2">Location of Label
                            </h2>
                            <table className="w-full border-collapse border border-gray-300 text-left mb-6">
                                <thead>
                                    <tr>
                                        <th className="border border-gray-300 p-2">Essential
                                            Data
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="border border-gray-300 p-2">
                                            <ul className="list-disc list-inside">
                                                <li>Barcode</li>
                                                <li>
                                                    Paste the label on the seamless flat face of
                                                    the box/flyer

                                                </li>
                                                <li>Paste the label away from the seams or
                                                    edges of the box
                                                </li>
                                                <li> Readability of barcode is important for faster
                                                    and correct processing of shipments</li>
                                                <li>In flyers/polybags all the essential data on
                                                    labels should be visible and the label should
                                                    be placed flat</li>
                                                <li>The pocket containing the label in the flyer
                                                    should be taped at the opening to avoid the
                                                    loss of label </li>
                                                <li>Thermal printed labels are strongly
                                                    recommended over regular labels</li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="flex justify-center">
                            <img
                                src="https://uklogistics.s3.ap-south-1.amazonaws.com/packaging-guidline/cap14.PNG"
                                alt="Shipment Label Example"
                                className="h-96"
                            />
                        </div>
                    </div>
                </div>

                <div>
                    <div className="grid grid-cols-1 items-center sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        <div>
                            <img
                                src="https://uklogistics.s3.ap-south-1.amazonaws.com/packaging-guidline/cap20.PNG"
                                alt="Heat Shrink Sleeves"
                                className="mb-4"
                            />
                        </div>

                        <div>
                            <img
                                src="https://uklogistics.s3.ap-south-1.amazonaws.com/packaging-guidline/cap21.PNG"
                                alt="Taping Of Bottle Caps"
                                className="mb-4"
                            />
                        </div>

                        <div>
                            <img
                                src="https://uklogistics.s3.ap-south-1.amazonaws.com/packaging-guidline/cap22.PNG"
                                alt="Zip Lock or Leak Proof Pouches"
                                className="mb-4"
                            />
                        </div>
                        <div>
                            <img
                                src="https://uklogistics.s3.ap-south-1.amazonaws.com/packaging-guidline/cap23.PNG"
                                alt="Zip Lock or Leak Proof Pouches"
                                className="mb-4"
                            />
                        </div>
                        <div>
                            <img
                                src="https://uklogistics.s3.ap-south-1.amazonaws.com/packaging-guidline/cap24.PNG"
                                alt="Zip Lock or Leak Proof Pouches"
                                className="mb-4 saturate-50"
                            />
                        </div>
                    </div>
                </div> */}

                <div className='space-y-7'>
                    <p className='font-semibold text-lg'>Domestic Parcel Services in India: A Comprehensive Overview
                    </p>
                    <p>India's domestic parcel services have become a vital part of the country's logistics ecosystem, catering to the needs of individuals, businesses, and e-commerce platforms. As India's economy continues to grow and the demand for faster, more efficient transportation rises, domestic parcel services have evolved to provide a wide array of options for customers. Whether it's sending small personal items, large packages, or time-sensitive documents, the domestic parcel industry has adapted to meet the varied needs of a diverse population.</p>
                </div>

                <div className='space-y-7 mt-10'>
                    <p className='font-semibold text-lg'>Key Features of Domestic Parcel Services
                    </p>
                    <p>Domestic parcel services in India come with various features designed to ensure safety, speed, and convenience. Here are some of the essential features that customers can expect:</p>

                    <p>Tracking and Monitoring: Most parcel service providers offer real-time tracking, allowing customers to monitor their parcel's journey. This feature enhances transparency and reduces concerns about delays or lost packages.</p>
                    <p>Insurance: For high-value or fragile parcels, customers can opt for insurance coverage. This ensures that in case of damage or loss, they will be compensated. Insurance is particularly important for businesses shipping electronics, jewelry, or other expensive items.

                    </p>
                    <p>Packaging Services: Some parcel service providers offer specialized packaging options to ensure the safety of the contents. This is crucial for fragile items such as glassware, electronics, or artwork, as proper packaging reduces the risk of damage during transit.</p>
                    <p>Door-to-Door Delivery: Convenience is a major factor for many customers, and door-to-door delivery ensures that parcels are picked up from the sender’s location and delivered directly to the recipient. This is a popular feature, especially for businesses and e-commerce platforms.</p>
                    <p>Multiple Delivery Speeds: Customers can choose from different delivery speeds based on their needs and budget. While express and same-day delivery services are available for urgent shipments, standard services provide a more affordable option for non-urgent parcels.</p>
                </div>



                <div className='space-y-7 mt-10'>
                    <p className='font-semibold text-lg'>Challenges in Domestic Parcel Services
                    </p>
                    <p>While India's domestic parcel services have improved significantly over the years, some challenges remain:</p>
                    <p>Rural Accessibility: Delivering parcels to remote or rural areas can still be a challenge for many logistics companies. Poor road infrastructure, lack of digital connectivity, and geographical barriers can result in delays.</p>
                    <p>Security Concerns: Although parcel services offer insurance options, incidents of lost or damaged parcels do occasionally occur. Ensuring secure handling and transportation of valuable goods remains a priority for logistics companies.

                    </p>
                    <p>Cost Variations: The cost of parcel delivery can vary significantly depending on the service provider, the size of the parcel, the distance, and the speed of delivery. Some services can be prohibitively expensive for small businesses or individual customers, particularly in the case of express or same-day deliveries.

                    </p>
                </div>

                <div className='space-y-7 mt-10'>
                    <p className='font-semibold text-lg'>Document Parcel Services in India: A Specialized Solution
                    </p>
                    <p>Document (paper) parcel services in India are an essential part of logistics, handling the transportation of important legal papers, contracts, certificates, academic records, and business proposals. These services cater to a wide range of customers, from individuals sending personal documents to businesses handling time-sensitive or confidential paperwork.</p>
                </div>

                <div className='space-y-7 mt-10'>
                    <p className='font-semibold text-lg'>1. Importance of Document Parcel Services
                    </p>
                    <p>Sending documents safely and securely is of paramount importance in many sectors, including education, law, business, and government. Document parcel services ensure that important papers are delivered on time, in pristine condition, and with proper security measures in place. For instance:</p>
                    <p>- Legal Documents: Lawyers and law firms often rely on document parcel services to send legal notices, contracts, or court-related paperwork.</p>
                    <p>- Business Transactions: Companies frequently send contracts, agreements, and proposals that require quick delivery and proof of receipt.</p>
                    <p>- Educational Records: Students or institutions may need to send official transcripts, certificates, or application forms, which are often time-sensitive.</p>
                </div>

            </div>
            <AddressModal data={getReceiverData} setPage={setPage} page={page} limit={limit} setPickupId={setPickupId} refetch={reciverRefetch} show={showModal} onClose={() => setShowModal(false)} setShowModal={setShowModal} setShowModalAddress={setShowModalAddress} setSelectedPickupAddress={setSelectedPickupAddress} />
            <AddressDetailsModel pickupId={pickupId} refetch={reciverRefetch} show={showModalAddress} onClose={handleCloseAddressDetails} setShowModalAddress={setShowModalAddress} setShowModal={setShowModal} setPickupAddress={setPickupAddress} pickupAddress={pickupAddress} setSelectedPickupAddress={setSelectedPickupAddress} />
            <DeliveryDetailsModel refetch={refetch} deliveryId={deliveryId} show={deliveryModal} onClose={handleCloseDeliveryDetails} setdeliveryModal={setdeliveryModal} setdeliveryShowModal={setdeliveryShowModal} setDeliveryAddress={setDeliveryAddress} deliveryAddress={deliveryAddress} setSelectedDeliveryAddress={setSelectedDeliveryAddress} setDeliveryId={setDeliveryId} />
            <DeliveryModal loading={loading} setSearchDelhiveryAddress={setSearchDelhiveryAddress} refetch={refetch} limitDelivery={limitDelivery} pageDelivery={pageDelivery} setPageDelivery={setPageDelivery} setDeliveryId={setDeliveryId} show={deliveryshowModal} data={getDeliveryData} onClose={() => setdeliveryShowModal(false)} setdeliveryShowModal={setdeliveryShowModal} setdeliveryModal={setdeliveryModal} setSelectedDeliveryAddress={setSelectedDeliveryAddress} />
            {/* <PaymentTotalModel setcourier_id={setcourier_id} setWeightInput={setWeightInput} setWeightType={setWeightType} setProductName={setProductName} setProductPrice={setProductPrice} setPaymentType={setPaymentType} setSelectedPickupAddress={setSelectedPickupAddress} setSelectedDeliveryAddress={setSelectedDeliveryAddress} data={data} show={paymentShowModel} onClose={() => setPaymentShowModel(false)} setPaymentShowModel={setPaymentShowModel} setHandlePayModel={setHandlePayModel} /> */}
            <BankDetailsModal show={showBankModal} onClose={() => setShowBankModal(false)} />
            <Footer />
        </div>
    )
}

export default DocumentShipping
